import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  standalone: true,
  providers: [AppService],
  imports: [CommonModule, RouterOutlet],
  template: `
    <div class="w-full pb-16">
      <div
        class="w-full bg-primary text-white bg-header-bg bg-no-repeat bg-right bg-blend-soft-light"
        style="background-position-x: calc(100% + 150px);"
      >
        <a
          routerLink="/"
          class="w-full max-w-4xl mx-auto flex items-center py-8 px-4"
        >
          <img src="/assets/images/ceos-logo.png" class="h-[80px]" />
        </a>
      </div>
      <div class="w-full max-w-4xl mx-auto py-8">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: [],
})
export class AppComponent {}
